module.exports = __webpack_public_path__ + "e5d68987fe0ac294dac8c4405bdf7985.png";